export var REPORT_REPOSITORY_WEB_CONFIG = 'REPORT_REPOSITORY_WEB_CONFIG';